// extracted by mini-css-extract-plugin
export var container = "_4p-0";
export var icon = "_4p-1";
export var text = "_4p-2";